module.exports = __webpack_public_path__ + "static/media/at-icon.219ae4f3.svg";